import { types } from '@saucelabs/sl-module-root-cause';

export const NAMESPACE = 'analytics-root-causes';
export default types.createTypes(NAMESPACE);
